// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_bOG","cls2":"ImpactHubModal-cls2_zgw ImpactHubModal-cls1_bOG"};